export const FirebaseConfig = {
	"projectId": "zungukacouriers-79c35",
	"appId": "1:964358163981:web:d8355b0f9d5c3615d28f44",
	"databaseURL": "https://zungukacouriers-79c35-default-rtdb.firebaseio.com",
	"storageBucket": "zungukacouriers-79c35.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyCk_caT0r55h4aneUuErdmBa0HUK9YqdP4",
	"authDomain": "zungukacouriers-79c35.firebaseapp.com",
	"messagingSenderId": "964358163981",
	"measurementId": "G-D6EN8N94J6"
};